import { Box, useTheme } from "@mui/material"

type KitHeaderItem = {
  children: JSX.Element | null,
}

const KitHeaderItem = (props: KitHeaderItem) => {
  const { children } = props

  const theme = useTheme()

  return (
    <Box className="flex flex-align-center c-g-8 m-b-8 p-12" sx={{ flexWrap: 'wrap', borderRadius: '4px', border: 1, borderColor: theme.palette.grey[300] }}>
      { children }
    </Box>    
  )
}

export default KitHeaderItem
